var styleDataHash = "af9ba4bc";
const injectCss = () => {
  var css = `.b-Ynx{box-sizing:border-box;height:29px;max-width:100%;width:100%}[dir] .b-Ynx{margin:0 auto;padding-top:14px}[dir] ._2CZFg{padding-top:11px}.kbNya{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}._0oeIb,._8YNrY,.p7Hvn,.t4Ye9{height:100%}.t4Ye9{stroke-dasharray:4 4}.p7Hvn{stroke-dasharray:1 5}.K9hOm{width:10%}.ZOUMR{width:40%}.huqDC{width:100%}[dir=ltr] ._2OPsc{margin-right:auto}[dir=rtl] ._2OPsc{margin-left:auto}[dir] .P-IKQ{margin:0 auto}[dir=ltr] .VXF4b{margin-left:auto}[dir=rtl] .VXF4b{margin-right:auto}.dOo8n{height:100%}.dOo8n .DlQqy{height:1px}._2-OmA{align-items:center;display:flex;height:38px}[dir=ltr] ._2-OmA{padding:0 30px 0 0!important}[dir=rtl] ._2-OmA{padding:0 0 0 30px!important}._3u9NX{height:18px;max-width:60px;overflow:hidden;width:60px}[dir] ._3u9NX{padding-top:7px}.GEV7F{stroke:currentColor!important}.uL7Zp{width:100%}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_styles_default = {
  "divider-container": "b-Ynx",
  "divider-container--double": "_2CZFg",
  "divider": "kbNya",
  "divider--single": "_0oeIb",
  "divider--double": "_8YNrY",
  "divider--dashed": "t4Ye9",
  "divider--dotted": "p7Hvn",
  "divider--small": "K9hOm",
  "divider--medium": "ZOUMR",
  "divider--large": "huqDC",
  "divider--left": "_2OPsc",
  "divider--center": "P-IKQ",
  "divider--right": "VXF4b",
  "svgFixerContainer": "dOo8n",
  "emptyChar": "DlQqy",
  "divider-dropdown__control": "_2-OmA",
  "divider-dropdown__option": "_3u9NX",
  "divider-dropdown__divider": "GEV7F",
  "divider_line_icon": "uL7Zp"
};
export {
  default_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-styles-scss.js.map
